import { useFormContext } from 'react-hook-form'
import EdSwitch from '@/components/forms/EdSwitch'

interface DocumentoFineCorso {
  id_documento_fine_corso: string;
  nome_documento: string;
  id_documenti_finali: string | null;
  mandatorio: string;
  nome_tipologia: string | null;
  attivo: string;
}

interface DocumentsSectionProps {
  isReadOnly?: boolean;
  data?: DocumentoFineCorso[];
}

const DocumentsSection = ({ isReadOnly = false, data = [] }: DocumentsSectionProps) => {
  const { watch, setValue } = useFormContext();

  const selections = watch('documentiSelezionati') || {};
  const selectionsMandatorio = watch('documentiMandatorio') || {};

  return (
    <div className="flex flex-col gap-1">
      <span className="text-[20px] text-[#4F4F4F] font-bold mt-2">Documenti di fine corso</span>
      <div className="w-full">
        {data.length > 0 && data.map((item, idx) => {
            const checked = item.attivo === '1' || !!selections?.[item.id_documento_fine_corso];
            const mandatorio = item.mandatorio === '1' || !!selectionsMandatorio?.[item.id_documento_fine_corso];
            return (
              <div key={item.id_documento_fine_corso} className={`flex items-center justify-between px-0 py-1.5 ${idx !== data.length - 1 ? 'border-b border-gray-200' : ''}`}>
                <div className="flex items-center gap-12">
                  <span className="text-sm text-black min-w-[180px]">{item.nome_documento}</span>
                  <span className="text-sm text-[#6B7280]">{item.nome_tipologia || '--'}</span>
                </div>
                <div className="flex items-center gap-2">
                  <EdSwitch
                    id={`doc-mandatorio-${item.id_documento_fine_corso}`}
                    value={mandatorio}
                    onChange={() => setValue(`documentiMandatorio.${item.id_documento_fine_corso}`, !mandatorio, { shouldDirty: true })}
                    disabled={isReadOnly}
                  />
                  <span className={`text-sm ${mandatorio ? 'text-black' : 'text-gray-400'}`}>Obbligatorio</span>
                </div>
                <div className="flex items-center gap-2">
                  <EdSwitch
                    id={`doc-attivo-${item.id_documento_fine_corso}`}
                    value={checked}
                    onChange={() => setValue(`documentiSelezionati.${item.id_documento_fine_corso}`, !checked, { shouldDirty: true })}
                    disabled={isReadOnly}
                  />
                  <span className={`text-sm ${checked ? 'text-black' : 'text-gray-400'}`}>Selezionato</span>
                </div>
              </div>
            );
        })}
      </div>
    </div>
  )
}

export default DocumentsSection
